import cx from 'classnames'
import PropTypes from 'prop-types'
import styles from './Card.module.scss'

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

export default function Card({ children, className }) {
  return (
    <div className={cx(styles.card, className)}>
      {children}
    </div>
  )
}
